import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';

// API Base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://trademark.test/api';
const SANCTUM_BASE_URL = process.env.REACT_APP_SANCTUM_URL || 'http://trademark.test';

// Create axios instance
const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// CSRF Token获取函数 (暂时简化，使用 token 认证)
const getCsrfToken = async (): Promise<void> => {
  // 简化版本，不使用 CSRF
  return Promise.resolve();
};

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const requestUrl = error.config?.url || '';
    const shouldBypassRedirect = ['/auth/login', '/auth/register', '/auth/wechat/login'].some((path) => requestUrl.includes(path));

    if (error.response?.status === 401 && !shouldBypassRedirect) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// 导出API实例和CSRF函数
export { getCsrfToken };
export default api;
